/* eslint-disable  no-else-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// components
import ControlType from '../../template/ControlType/ControlType';
import NumberTime from '../InputTypes/NumberTime/NumberTime';
import { formatDateToInput } from '../../../utils/dates';

function DegHeureList({ list, submit }) {
  // Hooks
  const { t } = useTranslation();
  const columns = [
    {
      label: '',
      width: 160,
    },
    {
      label: t('inputs.degrees_value'),
      width: 160,
    },
    {
      label: t('inputs.recorded_time'),
      width: 160,
    },
  ];
  const initialList = list.map((input) => ({ ...input, isDirty: false }));
  const [inputsList, setInputsList] = useState(initialList);

  const handleChange = (input) => {
    const resultsChanged = inputsList.map((inputState) => {
      if (inputState.id === input.id) return ({ ...input, isDirty: true });
      return inputState;
    });
    setInputsList(resultsChanged);
  };

  const dateRecord = formatDateToInput(new Date());

  const currentDate = new Date();
  const currentHours = (`0${currentDate.getHours()}`).slice(-2);
  const currentMinutes = (`0${currentDate.getMinutes()}`).slice(-2);
  const currentTime = `${currentHours}:${currentMinutes}`;

  const handleValuesSubmit = () => {
    const valuesToSubmit = inputsList
      .filter((input) => {
        if (input.isDirty && input.degreeValue !== '') return true;
        return false;
      })
      .map((input) => ({
        inputId: input?.id,
        degreeValue: input?.degreeValue,
        recordDate: input?.time === undefined ? `${dateRecord} ${currentTime}:00` : `${dateRecord} ${input.time}:00`,
        alertComment: input?.alertComment,
        alert: input?.alert,
        alertHelp: input?.alertHelp,
      }));
    submit(valuesToSubmit);
  };

  return (
    <ControlType columns={columns} onSubmit={handleValuesSubmit}>
      {inputsList.map((input) => (
        <NumberTime
          key={input.id}
          id={input.id}
          label={input.title}
          value={input}
          onChange={handleChange}
        />
      ))}
    </ControlType>
  );
}

DegHeureList.propTypes = {
  list: PropTypes.array.isRequired,
  submit: PropTypes.func.isRequired,
};

export default DegHeureList;
